export default __webpack_public_path__ + "static/media/healthy-thinking.4d88daf6.svg";